import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class TextP extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M5.6,3.2H8c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.7,0.2,0.9,0.4c0.3,0.2,0.4,0.4,0.6,0.7c0.1,0.3,0.2,0.7,0.2,1.1
          c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8C9.9,7.5,9.6,7.7,9.2,7.8C8.9,7.9,8.5,7.9,8,7.9H6.6V11h-1V3.2z M7.9,7.1
          c0.7,0,1.2-0.1,1.5-0.4C9.8,6.5,9.9,6,9.9,5.5c0-0.6-0.2-1-0.5-1.2C9.1,4.1,8.6,4,7.9,4H6.6v3.1H7.9z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/TextP.js